import React from "react";
import { useHistory } from "react-router-dom";
import ActivityCard from "../../components/ActivityCard";
import MetricsCard from "../../components/MetricsCard";
import PrimaryTheme from "../../Themes/Primary";
import { Reducers, Dashboard as Dash } from "../../Interfaces/Interfaces";
import { useDispatch, useSelector } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import jwt from "jsonwebtoken";
import {
  getCashoutAccount,
  getAggregatorDashboard,
} from "../../redux/actions/userActions";
import { useSnackbar } from "notistack";
import DenseAppBar from "../../components/AppBar";
import Meter from "../../components/Meter";
import { Tokens } from "../../Interfaces/Interfaces";
import {
  getAchievementAction,
  getAgentActivityChartAction,
  getAgentDashboard,
  getAgentPerformanceDashboardAction,
  getAggregatorCountDashboard,
  getAggregatorPerformanceDashboardAction,
  getAnalyticalUpdateDashboardAction,
  getBottomAgentDashboardAction,
  getEarningComissionDashboardAction,
  getEarningDashboard,
  getFloatDashboardAction,
  getPerFormanceMetricsAndComissionAction,
  getPosDashboardAction,
  getTransactionCountDashboardSummaryAction,
  getTransactionDashboard,
} from "../../redux/actions/DashboardActions";
import { getCurrency, getDate, getDateTime } from "../../helpers/Functions";
import {
  getPerformanceTarget,
  getTransactions,
} from "../../redux/actions/TransactionActions";
import "./dashboard.scss";

import Select from "../../components/Select";
import Charts from "../../components/charts";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import PaginationControlled from "../../components/Pagination";


import Top10Header from "../../components/top10header";
import Placeholder from "../../components/Skeleton";
import Filters from "../../components/Filters";
import TransferGraph from "./transferGraph";
import { getAllAgentsActions } from "../../redux/actions/AgentActions";
import TransactionChart from "./transactionChart";
import { Icon } from "@material-ui/core";
import DateFilter from "../../components/dateFilter";
import { TokenValidator } from "../../services/TokenValidator";
import moment from "moment";
export default function AggregatorDashboard() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: any) => state.user);
  const dashboard = useSelector((state: any) => state.dashboard);
  const agentDashboard = useSelector((state: Reducers) => state.agentDashboard);

  const getAchievement = useSelector((state: Reducers) => state.getAchievement);
  const getPerformanceAndCommissions = useSelector(
    (state: any) => state.getPerformanceAndCommissions
  );
  const getPosMetricsDashboard = useSelector(
    (state: any) => state.getPosMetricsDashboard
  );
  const getCommissionEarningFilterDashboard = useSelector(
    (state: any) => state.getCommissionEarningFilterDashboard
  );  

  const [downloadLoader, setdownloadLoader]: any = React.useState(false);
  const [aggrgatordownloadLoader, setaggrgatordownloadLoader]: any =
    React.useState(false);
  const loader = useSelector((state: Reducers) => state.internalLoader);
  const target = useSelector((state: Reducers) => state.target);

  const transactionCountDashboardSummary = useSelector(
    (state: any) => state.transactionCountDashboardSummary
  );
  const agentActivityChart = useSelector(
    (state: any) => state.agentActivityChart
  );

  // get Lis of agents
  const getAgentPerformanceDashboard = useSelector(
    (state: any) => state.getAgentPerformanceDashboard
  );

  const getAggregatorPerformanceDashboard = useSelector(
    (state: any) => state.getAggregatorPerformanceDashboard
  );

  const getFloatBalanceDashboard = useSelector(
    (state: any) => state.getFloatBalanceDashboard
  );

  const token = TokenValidator();

  const [period, setPeriod] = React.useState(1);
  const [transPeriod, setTransPeriod]: any = React.useState(1);
  const [agentPeriod, setAgentPeriod] = React.useState(1);
  const [agentChartPeriod, setagentChartPeriod] = React.useState(1);
  const [achievementPeriod, setachievementPeriod] = React.useState(1);
  const [earningsPeriod, setEarningsPeriod] = React.useState(1);
  const [targetPeriod, setTargetPeriod] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  const [agentLoading, setAgentLoading] = React.useState(false);
  const [AgentChartLoading, setAgentChartLoading] = React.useState(false);
  const [transLoading, setTransLoading] = React.useState(false);
  const [earningLoading, setEarningLoading] = React.useState(false);
  const [targetLoading, setTargetLoading] = React.useState(false);
  const userType = useSelector((state: Reducers) => state.userType);
  const [EarningFilterPeriod, setEarningFilterPeriod] = React.useState(
    getPosMetricsDashboard.total
  );
  const [AgentFilterPeriod, setAgentFilter]: any = React.useState(4);
  const [AgentChartFilterPeriod, setAgentChartFilterPeriod]: any =
    React.useState(1);
  const [AchievementFilterPeriod, setAchievementFilterPeriod]: any =
    React.useState(1);
  const [AchievementLoading, setAchievementLoading] = React.useState(false);
  const [NewTransaction, setNewTransaction]: any = React.useState(
    transactionCountDashboardSummary.todayTotalAmount
  );
  const [NewAgentChartState, setNewAgentChartState]: any = React.useState({
    active: agentActivityChart.weekTotalActiveAgent,
    inactive: agentActivityChart.weekTotalInactiveAgent,
  });
  const [NewPOSChartState, setNewPOSChartState]: any = React.useState({
    active: agentActivityChart.todayTotalActivePos,
    inactive: agentActivityChart.todayTotalInactivePos,
  });
  const [NewComissionChartState, setNewComissionChartState]: any =
    React.useState({
      active: agentActivityChart.todayTotalAgentWithCommission,
      inactive: agentActivityChart.todayTotalAgentWithNoCommission,
    });
  const [TransferTargetState, setTransferTargetState]: any = React.useState(0);
  const [POSWithdrawState, setPOSWithdrawState]: any = React.useState(0);
  const [SearchState, setSearchState]: any = React.useState("");
  const [SearchTransferState, setSearchTransferState]: any = React.useState("");

  const [TransferClickFilter, setTransferClickFilter]: any = React.useState("");
  var d = new Date();
  d.setDate(d.getDate() - 2);

  var date = new Date();
  date.setDate(date.getDate() - 1)

  const [rangeState, setrangeState]: any = React.useState([
    {
      startDate: date,
      endDate: date,
      key: "selection",
    },
  ]);
  

  const [agentNewValue, setagentNewValue] = React.useState(
    agentDashboard.totalAgentWithPos
  );

  const [value, setValue] = React.useState(
    target && target.targetPercentage ? target.targetPercentage : 0
  );
  const [topAgentFilter, settopAgentFilter] = React.useState(1);

  const [bottomAgentFilter, setbottomAgentFilter] = React.useState(1);

  const [FloatCardLoading, setFloatCardLoading] = React.useState(false);
  const [EarningMenuValue, setEarningMenuValue] = React.useState("Today");
  const [EarningAmountLoader, setEarningAmountLoader] = React.useState(false);
  const [pageSize, setPageSize] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [pageSize2, setPageSize2] = React.useState(10);
  const [page2, setPage2] = React.useState(0);



  let AggregatorList: any =
    getAggregatorPerformanceDashboard && getAggregatorPerformanceDashboard.data;
    
    let list1: any =
    getAgentPerformanceDashboard && getAgentPerformanceDashboard.data;    

  let filter = { period };
  let filterEarning = { period: EarningFilterPeriod };
  let agentFilter = { period: agentPeriod };
  let targetFilter = { period: targetPeriod };
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
    // page: 1,
    // pageSize: 10,
    // id: user.id,
    // whereCondition: JSON.stringify(filter),
  };
  const paginationConfig2 = {
    page: page2 + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter)
  };

  const callTerminals = () => {
    paginationConfig.whereCondition = JSON.stringify(filter);
    dispatch(getAggregatorPerformanceDashboardAction(paginationConfig));
  };
  const callTerminals2 = () => {
    paginationConfig.whereCondition = JSON.stringify(filter);
    dispatch(getAgentPerformanceDashboardAction(paginationConfig2));
  };

  const getIndexSeed1 = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };
  const getIndexSeed = (index: number) => {
    paginationConfig2.page = page2 + 1;
    return (paginationConfig2.page - 1) * paginationConfig2.pageSize + index + 1;
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    setPageSize(value.props.value);
    paginationConfig.pageSize = value.props.value;
    callTerminals();
  };
  const handleChange2 = (event: React.ChangeEvent<unknown>, value: number) => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    callTerminals2();
    setPage2(value);
  };

  const handlePageSizeChange2 = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    setPageSize2(value.props.value);
    paginationConfig2.pageSize = value.props.value;
    callTerminals2();
  };

  const handleChange1 = (value: any) => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    callTerminals();
    setPage(value);
  };
  const handleChange = (value: any) => {
    setTransLoading(true);
    setTransPeriod(value);
    setPeriod(value);
    setPage(value);
  };
  const handleTarget = (value: any) => {
    setTargetLoading(true);
    setTargetPeriod(value);
  };
  const handleChangeAgent = (value: any) => {
    setAgentLoading(true);
    setAgentPeriod(value);
    setAgentFilter(value);
  };
  const handleChangeEarning = (value: any) => {
    setEarningLoading(true);
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    setEarningsPeriod(value);
    switch (value) {
      case "1":
        setEarningFilterPeriod(getPosMetricsDashboard.total);

        break;
      case "2":
        setEarningFilterPeriod(getPosMetricsDashboard.active);
        break;
      case "3":
        setEarningFilterPeriod(getPosMetricsDashboard.inactive);

        break;
      case "4":
        setEarningFilterPeriod(getPosMetricsDashboard.nonTransacting);
        break;
      case "5":
        setEarningFilterPeriod(getPosMetricsDashboard.unassigned);
        break;
      default:
        setEarningFilterPeriod(getPosMetricsDashboard.total);
        break;
    }
  };

  React.useEffect(() => {
    
      dispatch({ type: "LOADING", payload: true });
      dispatch(getAgentPerformanceDashboardAction(paginationConfig));
    }, []);

  React.useEffect(() => {
    setEarningFilterPeriod(getPosMetricsDashboard.total);
  }, [getPosMetricsDashboard]);

  React.useEffect(() => {
    // dispatch({
    //   type: "INTERNAL_LOADER",
    //   payload: true,
    // });
    // settotalChartMetrics(agentActivityChart);
  }, [dispatch, agentActivityChart]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();



    // dispatch(getTransactions(paginationConfig));
    dispatch(getEarningDashboard(JSON.stringify(filterEarning)));
    dispatch(getAggregatorDashboard());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, earningsPeriod]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();


    // dispatch(getPerformanceTarget());
  }, [dispatch, targetPeriod]);
  React.useEffect(() => {
    setagentNewValue(agentDashboard.totalAgentWithPos);
  }, [agentDashboard]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    // dispatch(getTransactionCountDashboardSummaryAction());
  }, [dispatch, transPeriod]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();


    dispatch(getAgentDashboard());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, AgentFilterPeriod]);

  React.useEffect(() => {
    dispatch(getAggregatorDashboard());
    dispatch(getCashoutAccount(user.id));
    // dispatch(getPerformanceTarget());
    // dispatch(getTopAgentDashboardAction(topAgentFilter));
    // dispatch(getBottomAgentDashboardAction(bottomAgentFilter));
    // dispatch(getAgentActivityChartAction(AgentChartFilterPeriod));
    // dispatch(getAnalyticalUpdateDashboardAction());

    setNewTransaction(transactionCountDashboardSummary.todayTotalAmount);
    setNewPOSChartState({
      active: agentActivityChart.todayTotalActivePos,
      inactive: agentActivityChart.todayTotalInactivePos,
    });
    setNewAgentChartState({
      active: agentActivityChart.weekTotalActiveAgent,
      inactive: agentActivityChart.weekTotalInactiveAgent,
    });
    setNewComissionChartState({
      active: agentActivityChart.todayTotalAgentWithCommission,
      inactive: agentActivityChart.todayTotalAgentWithNoCommission,
    });
    setTransferTargetState(target.dailyTranferTransactionTargetCount);
    setPOSWithdrawState(target.dailyPosCashWithdrawalTransactionTargetCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  React.useEffect(() => {
    setTransferTargetState(target.dailyTranferTransactionTargetCount);
    setPOSWithdrawState(target.dailyPosCashWithdrawalTransactionTargetCount);
  }, [TransferTargetState, POSWithdrawState]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "ALERT",
          payload: {},
        });
        callTerminals();
        callTerminals2();


      } else {
        dispatch({
          type: "ALERT",
          payload: {},
        });
        callTerminals();
        callTerminals2();


      }
    }
  }, [dispatch, enqueueSnackbar, alert]);
  const handleTopAgent = (value: any) => {
    settopAgentFilter(value);
  };
  const handleBottomAgent = (value: any) => {
    setbottomAgentFilter(value);
  };
  React.useEffect(() => {
    switch (String(AgentFilterPeriod)) {
      case "4":
        setagentNewValue(agentDashboard.totalAgentWithPos);
        break;
      case "1":
        setagentNewValue(agentDashboard.totalAgent);
        break;
      case "2":
        setagentNewValue(agentDashboard.totalActiveAgent);
        break;
      case "3":
        setagentNewValue(agentDashboard.totalInactiveAgent);
        break;

      default:
        setagentNewValue(agentDashboard.totalAgentWithPos);
        break;
    }
    switch (String(transPeriod)) {
      case "1":
        setNewTransaction(transactionCountDashboardSummary.todayTotalAmount);
        break;
      case "2":
        setNewTransaction(transactionCountDashboardSummary.weekTotalAmount);
        break;
      case "3":
        setNewTransaction(transactionCountDashboardSummary.monthTotalAmount);
        break;

      default:
        setNewTransaction(transactionCountDashboardSummary.todayTotalAmount);
        break;
    }
    switch (String(AgentChartFilterPeriod)) {
      case "1":
        setNewAgentChartState({
          active: agentActivityChart.todayTotalActiveAgent,
          inactive: agentActivityChart.todayTotalInactiveAgent,
        });
        setNewPOSChartState({
          active: agentActivityChart.todayTotalActivePos,
          inactive: agentActivityChart.todayTotalInactivePos,
        });
        setNewComissionChartState({
          active: agentActivityChart.todayTotalAgentWithCommission,
          inactive: agentActivityChart.todayTotalAgentWithNoCommission,
        });
        break;
      case "2":
        setNewAgentChartState({
          active: agentActivityChart.weekTotalActiveAgent,
          inactive: agentActivityChart.weekTotalInactiveAgent,
        });
        setNewPOSChartState({
          active: agentActivityChart.weekTotalActivePos,
          inactive: agentActivityChart.weekTotalInactivePos,
        });
        setNewComissionChartState({
          active: agentActivityChart.weekTotalAgentWithCommission,
          inactive: agentActivityChart.weekTotalAgentWithNoCommission,
        });

        break;
      case "3":
        setNewAgentChartState({
          active: agentActivityChart.monthTotalActiveAgent,
          inactive: agentActivityChart.monthTotalInactiveAgent,
        });
        setNewPOSChartState({
          active: agentActivityChart.monthTotalactivePos,
          inactive: agentActivityChart.monthTotalInactivePos,
        });
        setNewComissionChartState({
          active: agentActivityChart.monthTotalAgentWithCommission,
          inactive: agentActivityChart.monthTotalAgentWithNoCommission,
        });

        break;

      default:
        setNewAgentChartState({
          active: agentActivityChart.weekTotalActiveAgent,
          inactive: agentActivityChart.weekTotalInactiveAgent,
        });
        setNewPOSChartState({
          active: agentActivityChart.todayTotalActivePos,
          inactive: agentActivityChart.todayTotalInactivePos,
        });
        setNewComissionChartState({
          active: agentActivityChart.todayTotalAgentWithCommission,
          inactive: agentActivityChart.todayTotalAgentWithNoCommission,
        });
        break;
    }
    switch (String(targetPeriod)) {
      case "1":
        setTransferTargetState(target.dailyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.dailyPosCashWithdrawalTransactionTargetCount
        );

        break;
      case "2":
        setTransferTargetState(target.weeklyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.weeklyPosCashWithdrawalTransactionTargetCount
        );

        break;
      case "3":
        setTransferTargetState(target.monthlyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.monthlyPosCashWithdrawalTransactionTargetCount
        );

        break;

      default:
        setTransferTargetState(target.dailyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.dailyPosCashWithdrawalTransactionTargetCount
        );

        break;
    }
  }, [
    AgentFilterPeriod,
    agentDashboard,
    transPeriod,
    NewTransaction,
    AgentChartFilterPeriod,
    targetPeriod,
    POSWithdrawState,
  ]);
  const handleChartActivityChange = (value: any) => {
    setAgentChartLoading(true);
    setagentChartPeriod(value);

    setAgentChartFilterPeriod(value);
  };
  const handleAchivementChange = (value: any) => {
    setAchievementLoading(true);
    setachievementPeriod(value);

    setAchievementFilterPeriod(value);
  };
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();


    // dispatch(getAgentActivityChartAction(AgentChartFilterPeriod));
  }, [AgentChartFilterPeriod]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();


    // dispatch(getAchievementAction(AchievementFilterPeriod));
  }, [AchievementFilterPeriod]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();


    // dispatch(getTopAgentDashboardAction(topAgentFilter));
  }, [dispatch, topAgentFilter]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();


    // dispatch(getBottomAgentDashboardAction(bottomAgentFilter));
  }, [dispatch, bottomAgentFilter]);
  const handleRoutePage = (index: any) => {
    switch (index) {
      case 0:
        history.push("/pos");
        break;
      case 1:
        history.push("/agents");
        break;
      case 2:
        history.push("/transactions");
        break;
      case 3:
        history.push("/agents");
        break;
      case 4:
        history.push("/agents");
        break;
      case 5:
        history.push("/agents");
        break;
      case 6:
        history.push("/pos");
        break;

      default:
        break;
    }
  };

  const getColor = (actual: any, totalTerget: any, status: any) => {
    if (actual > totalTerget) {
      return "badge-success";
    } else if (status) {
      return "badge-success";
    } else {
      return "badge-danger";
    }
  };
  const handleSelect = (date: any) => {
    setrangeState([date.selection]);
  };
  const handleGenerate = () => {
    let PFrilter = {
      whereCondition: "",
    };
    let date = {
      startDate: moment(rangeState[0].startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeState[0].endDate).format("YYYY-MM-DD"),
    };

    // console.log();
    // console.log(
    //   JSON.stringify(moment(rangeState[0].startDate).format("YYYY-MM-DD"))
    // );
    setFloatCardLoading(true);
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    PFrilter.whereCondition = JSON.stringify(date);
    dispatch(getPerFormanceMetricsAndComissionAction(PFrilter));
    dispatch(getAgentPerformanceDashboardAction(PFrilter));

    dispatch(getAggregatorPerformanceDashboardAction(PFrilter));
  };

  React.useEffect(() => {
    let PFrilter = {
      whereCondition: "",
    };
    let date = {
      startDate: rangeState[0].startDate,
      endDate: rangeState[0].endDate,
    };

    PFrilter.whereCondition = JSON.stringify(date);
    dispatch(getPerFormanceMetricsAndComissionAction(PFrilter));
    dispatch(getAgentPerformanceDashboardAction(PFrilter));

    dispatch(getAggregatorPerformanceDashboardAction(PFrilter));
  }, []);

  React.useEffect(() => {
    if (!loader) {
      setLoading(false);
      setEarningLoading(false);
      setTransLoading(false);
      setAgentLoading(false);
      setTargetLoading(false);

      setAgentChartLoading(false);
      setAchievementLoading(false);
      setFloatCardLoading(false);
      setEarningAmountLoader(false);
    }
  }, [loader]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();



    dispatch(getPosDashboardAction());
    dispatch(getFloatDashboardAction());
  }, [dispatch]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    callTerminals();
    callTerminals2();


    setEarningAmountLoader(true);

    dispatch(getEarningComissionDashboardAction(EarningMenuValue));
  }, [EarningMenuValue]);
  const handleDownloadSilverPartner = () => {
    setaggrgatordownloadLoader(true);
    let DownloadFilter = {
      whereCondition: "",
    };
    let date = {
      startDate: rangeState[0].startDate,
      endDate: rangeState[0].endDate,
    };

    DownloadFilter.whereCondition = JSON.stringify(date);

    fetch(
      `https://transaction-report-${process.env.REACT_APP_STAGE}-alb.bankly.ng/api/AggregatorDashboard/exportaggregatorrankingmetrics/${DownloadFilter.whereCondition}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token?.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      }
    ).then((response) => {
      setaggrgatordownloadLoader(false);
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "aggregator.csv";
        a.click();
      });
      //window.location.href = response.url;
    });
  };

  const handleDownloadAgentRecord = async () => {
    setdownloadLoader(true);
    let DownloadAgentFilter = {
      whereCondition: "",
    };
    let date = {
      startDate: rangeState[0].startDate,
      endDate: rangeState[0].endDate,
    };

    DownloadAgentFilter.whereCondition = JSON.stringify(date);
    fetch(
      `https://transaction-report-${process.env.REACT_APP_STAGE}-alb.bankly.ng/api/AggregatorDashboard/exportagentrankingmetrics/${DownloadAgentFilter.whereCondition}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token?.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      }
    ).then((response) => {
      setdownloadLoader(false);
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "agents.csv";
        a.click();
      });
      // window.location.href = response.url;
    });
  };

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>

      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div className="row m-0">
          <div
            className="col-md-12 p-0"
            style={{
              backgroundColor: PrimaryTheme.white,
              height: "100vh",
              position: "relative",
              // zIndex: 1000,
            }}
          >
            <div className="col-md-11 ml-auto mr-auto p-0 ">
              <div className="row m-0 mb-4">
                <div
                  className="col-md-12 content-area p-0 matrics-cover"
                  style={{
                    height: "auto",
                    position: "relative",
                  }}
                >
                  <div className="row ">
                    <div className="col-md-9 col-6 ">
                      <h4
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                        }}
                      >
                        Partner:{" "}
                        {user.businessName
                          ? user.businessName
                          : user.firstName + " " + user.lastName}
                      </h4>
                      {/* <h6 style={{
                        fontFamily: PrimaryTheme.fonts?.LightFont
                      }}>{dashboard.wallet ? dashboard.wallet.bankName : "N/A"}</h6> */}

                      <h4>
                        <span
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                          }}
                        >
                          {" "}
                          NUBAN:
                        </span>

                        <span>
                          {" "}
                          {dashboard.wallet
                            ? dashboard.wallet.bankName
                              ? dashboard.wallet.bankName
                              : "N/A"
                            : "N/A"}{" "}
                          |{" "}
                          {dashboard.wallet
                            ? dashboard.wallet.nuban
                              ? dashboard.wallet.nuban
                              : "N/A"
                            : "N/A"}
                        </span>
                      </h4>

                      {/* ID: BNK-{user.id && user.id} */}

                      {/* <h6
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                        }}
                      >
                       
                      </h6> */}
                      {/* user.state */}
                    </div>
                    <div className="col-6 col-md-3"></div>
                  </div>
                </div>
              </div>
              {/* cards  */}
              <div
                className="row mb-3"
                style={{ background: "white", position: "relative" }}
              >
                <div
                  className="col-12 matrics-cover "
                  style={{ height: "13.7vh", position: "absolute" }}
                ></div>

                {user?.isSuperAggregator ? (
                  <div
                    className="col-md col-12"
                    style={{
                      height: "auto",
                      position: "relative",
                    }}
                  >
                    <MetricsCard
                      id="fourth"
                      value={
                        dashboard?.totalAggregators
                          ? dashboard?.totalAggregators
                          : "0"
                      }
                      buttonColor={PrimaryTheme.primary}
                      hasButton
                      buttonClick={() => history.push(`/trade-partners`)}
                      buttonTitle="Manage Silver Partners"
                      title="SILVER PARTNERS"
                    />
                  </div>
                ) : (
                  ""
                )}
                <div
                  className="col-md col-12"
                  style={{
                    height: "auto",
                    position: "relative",
                  }}
                >
                  <MetricsCard
                    id="second"
                    value={
                      JSON.stringify(agentNewValue)
                        ? agentNewValue.toLocaleString()
                        : "0"
                    }
                    isLoading={agentLoading}
                    handleActive
                    onMenuChange={(e: any) => handleChangeAgent(e.target.value)}
                    buttonColor={PrimaryTheme.primary}
                    hasButton
                    buttonClick={() => history.push(`/agents`)}
                    buttonTitle="Manage Agents"
                    title="Agents"
                  />
                </div>
                <div
                  className="col-md col-12"
                  style={{
                    height: "auto",
                    position: "relative",
                  }}
                >
                  <MetricsCard
                    id="third"
                    isLoading={earningLoading}
                    onMenuChange={(e: any) =>
                      handleChangeEarning(e.target.value)
                    }
                    value={EarningFilterPeriod ? EarningFilterPeriod : "0"}
                    handlePOSMenu
                    hasButton
                    buttonColor={PrimaryTheme.primary}
                    buttonClick={() => history.push(`/pos`)}
                    buttonTitle="Manage POS"
                    title="POS"
                    isValue
                  />
                </div>
              </div>

              <div className="row" style={{ marginBottom: "42px" }}>
                <div className="col-md-6" style={{ marginTop: "58px" }}>
                  <MetricsCard
                    handleFloatBtn
                    id="first"
                    title="WALLET BALANCE"
                    value={
                      Object.keys(getFloatBalanceDashboard).length
                        ? getFloatBalanceDashboard?.amount
                          ? getCurrency(getFloatBalanceDashboard?.amount)
                          : getCurrency("0")
                        : getCurrency("0")
                    }
                    buttonTitle="."
                    hasButton
                    buttonColor={PrimaryTheme.white}
                    buttonClick={() => history.push(`/my-wallet`)}
                  />
                </div>
                <div className="col-md-6" style={{ marginTop: "58px" }}>
                  <MetricsCard
                    handleEarningMenu
                    id="first"
                    title="COMMISSIONS EARNED"
                    isLoading={EarningAmountLoader}
                    onMenuChange={(e: any) =>
                      setEarningMenuValue(e.target.value)
                    }
                    value={
                      dashboard.aggregatorCommissionBalance
                        ? dashboard.aggregatorCommissionBalance
                          ? getCurrency(
                              dashboard.aggregatorCommissionBalance
                            )
                          : getCurrency("0")
                        : getCurrency("0")
                    }
                    buttonTitle="."
                    hasButton
                    buttonColor={PrimaryTheme.white}
                    buttonClick={() => history.push(`/commissions`)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md col-12" style={{ marginBottom: "20px" }}>
                  <DateFilter
                    ranges={rangeState}
                    handleSelect={(item: any) => handleSelect(item)}
                    labelPosition="right"
                    widthRange={"col-md-12 col-12"}
                    customPlaceholder={
                      "Select a date and use the Click to Generate button to view below"
                    }
                  />
                  {/* <button>click me</button> */}
                </div>
                <div
                  className="col-md col-12 date-and-generate-date-div"
                  style={{ lineHeight: "60px" }}
                >
                  View from <span style={{ marginRight: "5px" }}>:</span>{" "}
                  {getDate(rangeState[0].startDate)}
                  <span style={{ marginLeft: "7px" }}>
                    <span style={{ marginRight: "4px", marginLeft: "4px" }}>
                      -
                    </span>{" "}
                    To <span style={{ marginRight: "5px" }}>:</span>
                    {getDate(rangeState[0].endDate)}
                  </span>
                  <span
                    className="generate-button-for-desktop"
                    onClick={handleGenerate}
                    style={{
                      background: PrimaryTheme.warn,
                      border: "none",
                      paddingTop: "0.375rem",
                      paddingBottom: "0.375rem",
                      paddingLeft: "0.75rem",
                      paddingRight: " 0.75rem",
                      boxShadow: "0px 4px 4px rgba(196, 196, 196, 0.37)",
                      borderRadius: "10px",
                      marginLeft: "7px",
                      cursor: "pointer",
                      fontWeight: 400,
                      fontSize: "18px",
                    }}
                  >
                    Click to Generate
                  </span>
                </div>
                <div className="col-12 button-div-for-mobile">
                  <span
                    className=""
                    onClick={handleGenerate}
                    style={{
                      background: PrimaryTheme.warn,
                      border: "none",
                      paddingTop: "0.375rem",
                      paddingBottom: "0.375rem",
                      paddingLeft: "0.75rem",
                      paddingRight: " 0.75rem",
                      boxShadow: "0px 4px 4px rgba(196, 196, 196, 0.37)",
                      borderRadius: "10px",
                      marginLeft: "7px",
                      cursor: "pointer",
                      fontWeight: 400,
                      fontSize: "18px",
                    }}
                  >
                    Click to Generate
                  </span>
                </div>
              </div>

              {/* quick actions */}
              {FloatCardLoading ? (
                <div
                  className="row"
                  style={{ background: "white", paddingBottom: "20px" }}
                >
                  <React.Fragment>
                    <div className="col-md-12 text-center">
                      <Placeholder
                        variant="text"
                        width={"100%"}
                        height={50}
                        animation="wave"
                        className="display-inline"
                      />
                    </div>
                    <div className="col-md-12 text-center">
                      <Placeholder
                        variant="text"
                        width={"100%"}
                        height={50}
                        animation="wave"
                        className="display-inline"
                      />
                    </div>
                    <div className="col-md-12 text-center">
                      <Placeholder
                        variant="text"
                        width={"100%"}
                        height={50}
                        animation="wave"
                        className="display-inline"
                      />
                    </div>
                  </React.Fragment>
                </div>
              ) : (
                <div
                  className="row"
                  style={{ background: "white", paddingBottom: "20px" }}
                >
                  {user?.isSuperAggregator ? (
                    <div
                      className="col-md col-12 mb-5"
                      style={{
                        height: "auto",
                        position: "relative",
                      }}
                    >
                      <div
                        className="p-4 bg-white box-shadow border-radius"
                        style={{
                          minHeight: 197,
                        }}
                      >
                        <h6
                          className="mb-3"
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            textTransform: "uppercase",
                            fontSize: PrimaryTheme.fontSizes?.small,
                          }}
                        >
                          <div className="row">
                            <div
                              className="col"
                              style={{ position: "relative" }}
                            >
                              {" "}
                              SILVER PARTNER PERFORMANCE
                            </div>
                          </div>
                        </h6>

                        <div className="row" style={{ height: "100%" }}>
                          <div
                            className="col-12"
                            style={{
                              fontSize: PrimaryTheme.fontSizes?.small,
                              fontWeight: 300,
                              textAlign: "center",
                              marginBottom: "19px",
                              marginTop: "30px",
                            }}
                          >
                            Activity * Total No of POS Assigned to Aggregators
                          </div>
                          <div className="col">
                            <div className="row">
                              <div
                                className="col"
                                style={{ textAlign: "center" }}
                              >
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions
                                        ?.aggregatorPerformance.posActual
                                    : 0}
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                    marginRight: "5px",
                                  }}
                                >
                                  {" "}
                                  /
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions
                                        ?.aggregatorPerformance.posTarget
                                    : 0}
                                </span>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  POS Withdrawals
                                </div>
                              </div>
                              <div
                                className="col"
                                style={{ textAlign: "center" }}
                              >
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions
                                        ?.aggregatorPerformance.transferActual
                                    : 0}
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                    marginRight: "5px",
                                  }}
                                >
                                  {" "}
                                  /
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions
                                        ?.aggregatorPerformance.transferTarget
                                    : 0}
                                </span>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Transfer
                                </div>
                              </div>
                              <div
                                className="col"
                                style={{ textAlign: "center" }}
                              >
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions?.aggregatorPerformance.totalPercentagePerformance.toFixed(
                                        1
                                      )
                                    : 0}
                                  %
                                </span>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  of Total Target Achieved
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {user?.isSuperAggregator ? (
                    <div
                      className="col-md col-12 mb-5"
                      style={{
                        height: "auto",
                        position: "relative",
                      }}
                    >
                      <div
                        className="p-4 bg-white box-shadow border-radius "
                        style={{
                          minHeight: 197,
                        }}
                      >
                        <h6
                          className="mb-3"
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            textTransform: "uppercase",
                            fontSize: PrimaryTheme.fontSizes?.small,
                          }}
                        >
                          <div className="row">
                            <div
                              className="col"
                              style={{ position: "relative" }}
                            >
                              {" "}
                              AGENT PERFORMANCE
                            </div>
                            <div
                              style={{
                                textAlign: "right",
                                fontSize: "10px",
                                fontWeight: 300,
                              }}
                            >
                              ***(unassigned POS will reflect below)
                            </div>
                          </div>
                        </h6>

                        <div className="row" style={{ height: "100%" }}>
                          <div
                            className="col-12"
                            style={{
                              fontSize: PrimaryTheme.fontSizes?.small,
                              fontWeight: 300,
                              textAlign: "center",
                              marginBottom: "19px",
                              marginTop: "30px",
                            }}
                          >
                            Activity * Total No of Assigned POS
                          </div>
                          <div className="col">
                            <div className="row">
                              <div
                                className="col"
                                style={{ textAlign: "center" }}
                              >
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions
                                        ?.agentPerformance?.posActual
                                    : 0}
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                    marginRight: "5px",
                                  }}
                                >
                                  {" "}
                                  /
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions
                                        ?.agentPerformance.posTarget
                                    : 0}
                                </span>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  POS Withdrawals
                                </div>
                              </div>
                              <div
                                className="col"
                                style={{ textAlign: "center" }}
                              >
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions
                                        ?.agentPerformance.transferActual
                                    : 0}
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                    marginRight: "5px",
                                  }}
                                >
                                  {" "}
                                  /
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions
                                        ?.agentPerformance.transferTarget
                                    : 0}
                                </span>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Transfer
                                </div>
                              </div>
                              <div
                                className="col"
                                style={{ textAlign: "center" }}
                              >
                                <span
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 500,
                                    color: PrimaryTheme.primary,
                                  }}
                                >
                                  {getPerformanceAndCommissions?.agentPerformance
                                    ? getPerformanceAndCommissions?.agentPerformance?.totalPercentagePerformance.toFixed(
                                        1
                                      )
                                    : 0}
                                  %
                                </span>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  of Total Target Achieved
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="col-md col-12 mb-5"
                      style={{
                        height: "auto",
                        position: "relative",
                      }}
                    >
                      <div
                        className="p-4 bg-white box-shadow border-radius "
                        style={{
                          minHeight: 197,
                        }}
                      >
                        <h6
                          className="mb-3"
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            textTransform: "uppercase",
                            fontSize: PrimaryTheme.fontSizes?.small,
                          }}
                        >
                          <div className="row">
                            <div
                              className="col"
                              style={{ position: "relative" }}
                            >
                              {" "}
                              AGENT PERFORMANCE
                            </div>
                            <div
                              style={{
                                textAlign: "right",
                                fontSize: "10px",
                                fontWeight: 300,
                              }}
                            >
                              ***(unassigned POS will reflect below)
                            </div>
                          </div>
                        </h6>

                        <div className="col-md-6 col-12 container">
                          <div
                            className="row"
                            style={{ height: "100%", textAlign: "center" }}
                          >
                            <div
                              className="col-12"
                              style={{
                                fontSize: PrimaryTheme.fontSizes?.small,
                                fontWeight: 300,
                                textAlign: "center",
                                marginBottom: "19px",
                                marginTop: "30px",
                              }}
                            >
                              Activity * Total No of Assigned POS
                            </div>
                            <div className="col">
                              <div className="row">
                                <div
                                  className="col"
                                  style={{ textAlign: "center" }}
                                >
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      color: PrimaryTheme.primary,
                                    }}
                                  >
                                    {getPerformanceAndCommissions?.agentPerformance
                                      ? getPerformanceAndCommissions
                                          ?.agentPerformance?.posActual
                                      : 0}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      color: PrimaryTheme.primary,
                                      marginRight: "5px",
                                    }}
                                  >
                                    {" "}
                                    /
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      color: PrimaryTheme.primary,
                                    }}
                                  >
                                    {getPerformanceAndCommissions?.agentPerformance
                                      ? getPerformanceAndCommissions
                                          ?.agentPerformance.posTarget
                                      : 0}
                                  </span>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    POS Withdrawals
                                  </div>
                                </div>
                                <div
                                  className="col"
                                  style={{ textAlign: "center" }}
                                >
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      color: PrimaryTheme.primary,
                                    }}
                                  >
                                    {getPerformanceAndCommissions?.agentPerformance
                                      ? getPerformanceAndCommissions
                                          ?.agentPerformance.transferActual
                                      : 0}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      color: PrimaryTheme.primary,
                                      marginRight: "5px",
                                    }}
                                  >
                                    {" "}
                                    /
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      color: PrimaryTheme.primary,
                                    }}
                                  >
                                    {getPerformanceAndCommissions?.agentPerformance
                                      ? getPerformanceAndCommissions
                                          ?.agentPerformance.transferTarget
                                      : 0}
                                  </span>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Transfer
                                  </div>
                                </div>
                                <div
                                  className="col"
                                  style={{ textAlign: "center" }}
                                >
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      color: PrimaryTheme.primary,
                                    }}
                                  >
                                    {getPerformanceAndCommissions?.agentPerformance
                                      ? getPerformanceAndCommissions?.agentPerformance?.totalPercentagePerformance.toFixed(
                                          1
                                        )
                                      : 0}
                                    %
                                  </span>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    of Total Target Achieved
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* aggregator rank */}
              {user.isSuperAggregator ? (
                <div
                  className="box-shadow border-radius "
                  style={{ marginTop: "34px", marginBottom: "40px" }}
                >
                  <div
                    style={{
                      paddingLeft: "40px",
                      paddingRight: "40px",
                      paddingTop: "40px",
                      fontWeight: 900,
                      fontSize: PrimaryTheme.fontSizes?.normal,
                    }}
                    className="row"
                  >
                    <div className="col-md col-12">SILVER PARTNER RANKING</div>
                    <div
                      className="col-md col-12"
                      style={{ textAlign: "right" }}
                    >
                      {aggrgatordownloadLoader ? (
                        <button
                          className="btn btn-light download__button"
                          style={{
                            color: PrimaryTheme.primary,
                          }}
                        >
                          Please wait...
                        </button>
                      ) : (
                        <button
                          className="btn btn-light download__button"
                          style={{
                            color: PrimaryTheme.primary,
                          }}
                          onClick={handleDownloadSilverPartner}
                        >
                          <div className="row justify-content-center align-items-center m-0">
                            Export Table
                            <Icon
                              fontSize="small"
                              style={{
                                marginRight: 5,
                              }}
                            >
                              download
                            </Icon>{" "}
                          </div>
                        </button>
                      )}
                    </div>
                  </div>
                  {FloatCardLoading ? (
                    <React.Fragment>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                    </React.Fragment>
                  ) : (
                    <div className="row">
                      <div className="col-md-12  mb-3">
                        <div style={{ marginBottom: "20px" }}></div>
                        {AggregatorList ? (
                          <React.Fragment>
                            <div
                              className="table-responsive"
                              style={{ maxHeight: "600px", overflowY: "auto" }}
                            >
                              <table className="table table-hover">
                                <thead className="thead-primary">
                                  <tr className="text-center">
                                    <th scope="col">S/N</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Number of Pos</th>

                                    <th scope="col">Pos Withdrawals</th>
                                    <th scope="col">Transfer</th>
                                    <th scope="col">TOTAL PERF (%)</th>
                                    <th scope="col">Status</th>

                                    <th scope="col">Total Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {AggregatorList.map(
                                    (item: any, index: number) => (
                                      <tr
                                        title="Click to view"
                                        key={index}
                                        className="pointer text-center"
                                      >
                                        <th scope="row">{getIndexSeed1(index)}</th>
                                        <td>
                                          {item.aggregatorName
                                            ? item.aggregatorName
                                            : "-"}
                                        </td>
                                        <td>
                                          {item.numberOfPos
                                            ? item.numberOfPos
                                            : 0}
                                        </td>

                                        <td>
                                          <span>
                                            {item.posActual
                                              ? item.posActual
                                              : 0}
                                            /
                                            {item.posTarget
                                              ? item.posTarget
                                              : 0}
                                          </span>
                                        </td>
                                        <td>
                                          <span>
                                            {" "}
                                            {item.transferActual
                                              ? item.transferActual
                                              : 0}
                                            /
                                            {item.transferTarget
                                              ? item.transferTarget
                                              : 0}
                                          </span>
                                        </td>
                                        <td>
                                          {item.totalPercentagePerformance
                                            ? item.totalPercentagePerformance.toFixed(
                                                1
                                              )
                                            : 0}
                                          %
                                        </td>
                                        <td>
                                          {item.onTrack ? (
                                            <button
                                              className={getColor(
                                                "",
                                                "",
                                                item.onTrack
                                              )}
                                              style={{
                                                border: "none",
                                                borderRadius: "26px",
                                                padding: "5px 10px 5px 10px",
                                                fontSize: "12px",
                                                fontWeight: 300,
                                              }}
                                            >
                                              {" "}
                                              {item.onTrack
                                                ? "On Track"
                                                : "Behind"}
                                            </button>
                                          ) : (
                                            <button
                                              className={getColor(
                                                "",
                                                "",
                                                item.onTrack
                                              )}
                                              style={{
                                                border: "none",
                                                borderRadius: "26px",
                                                padding: "5px 10px 5px 10px",
                                                fontSize: "12px",
                                                fontWeight: 300,
                                              }}
                                            >
                                              {" "}
                                              {item.onTrack
                                                ? "On Track"
                                                : "Behind"}
                                            </button>
                                          )}
                                        </td>
                                        <td>
                                          {item.totalTransactionAmount
                                            ? getCurrency(
                                                item.totalTransactionAmount
                                              )
                                            : getCurrency("0")}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {AggregatorList.length === 0 && (
                              <React.Fragment>
                                <p className="text-center mt-3 text-dark w-100">
                                  No result
                                </p>
                              </React.Fragment>
                            )}

                            <div className="col-md-12 p-0">
                              {getAggregatorPerformanceDashboard.totalItemCount&& (
                                <PaginationControlled
                                  onPageSizeChange={handlePageSizeChange}
                                  onChange={handleChange1}
                                  page={page}
                                  total={getAggregatorPerformanceDashboard.totalItemCount && getAggregatorPerformanceDashboard.totalItemCount}
                                  pageSize={pageSize}
                                />
                              )}
                            </div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <div className="col-md-12 text-center">
                              <Placeholder
                                variant="text"
                                width={"100%"}
                                height={50}
                                animation="wave"
                                className="display-inline"
                              />
                            </div>
                            <div className="col-md-12 text-center">
                              <Placeholder
                                variant="text"
                                width={"100%"}
                                height={50}
                                animation="wave"
                                className="display-inline"
                              />
                            </div>
                            <div className="col-md-12 text-center">
                              <Placeholder
                                variant="text"
                                width={"100%"}
                                height={50}
                                animation="wave"
                                className="display-inline"
                              />
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}

              {/* Agent Rank */}
              <div style={{ paddingBottom: "40px" }}>
                <div className="box-shadow border-radius">
                  <div
                    style={{
                      paddingLeft: "40px",
                      paddingRight: "40px",
                      paddingTop: "40px",
                      fontWeight: 900,
                      fontSize: PrimaryTheme.fontSizes?.normal,
                    }}
                    className="row"
                  >
                    <div className="col-md col-12">AGENT RANKING</div>
                    <div
                      className="col-md col-12"
                      style={{ textAlign: "right" }}
                    >
                      {downloadLoader ? (
                        <button
                          className="btn btn-light download__button"
                          style={{
                            color: PrimaryTheme.primary,
                          }}
                        >
                          Please wait...
                        </button>
                      ) : (
                        <button
                          className="btn btn-light download__button"
                          style={{
                            color: PrimaryTheme.primary,
                          }}
                          onClick={handleDownloadAgentRecord}
                        >
                          <div className="row justify-content-center align-items-center m-0">
                            Export Table
                            <Icon
                              fontSize="small"
                              style={{
                                marginRight: 5,
                              }}
                            >
                              download
                            </Icon>{" "}
                          </div>
                        </button>
                      )}
                    </div>
                  </div>
                  {FloatCardLoading ? (
                    <React.Fragment>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                    </React.Fragment>
                  ) : (
                    <div className="row">
                      <div className="col-md-12  mb-3">
                        <div style={{ marginBottom: "20px" }}></div>
                        {list1 ? (
                          <React.Fragment>
                            <div
                              className="table-responsive"
                              style={{ maxHeight: "600px", overflowY: "auto" }}
                            >
                              <table className="table table-hover">
                                <thead className="thead-primary">
                                  <tr className="text-center">
                                    <th scope="col">S/N</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Number of Pos</th>

                                    <th scope="col">Pos Withdrawals</th>
                                    <th scope="col">Transfer</th>
                                    <th scope="col">TOTAL PERF (%)</th>
                                    <th scope="col">Status</th>

                                    <th scope="col">Total Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {list1.map((item: any, index: number) => (
                                    <tr
                                      title="Click to view"
                                      key={index}
                                      className="pointer text-center"
                                    >
                                      <th scope="row">{getIndexSeed(index)}</th>
                                      <td>
                                        {item.agentName ? item.agentName : "-"}
                                      </td>
                                      <td>
                                        {item.numberOfPos
                                          ? item.numberOfPos
                                          : 0}
                                      </td>

                                      <td>
                                        <span>
                                          {" "}
                                          {item.posActual ? item.posActual : 0}/
                                          {item.posTarget ? item.posTarget : 0}
                                        </span>
                                      </td>
                                      <td>
                                        <span>
                                          {" "}
                                          {item.transferActual
                                            ? item.transferActual
                                            : 0}
                                          /
                                          {item.transferTarget
                                            ? item.transferTarget
                                            : 0}
                                        </span>
                                      </td>
                                      <td>
                                        {item.totalPercentagePerformance
                                          ? item.totalPercentagePerformance.toFixed(
                                              1
                                            )
                                          : 0}
                                        %
                                      </td>
                                      <td>
                                        {item.onTrack ? (
                                          <button
                                            className={getColor(
                                              "",
                                              "",
                                              item.onTrack
                                            )}
                                            style={{
                                              border: "none",
                                              borderRadius: "26px",
                                              padding: "5px 10px 5px 10px",
                                              fontSize: "12px",
                                              fontWeight: 300,
                                            }}
                                          >
                                            {" "}
                                            {item.onTrack
                                              ? "On Track"
                                              : "Behind"}
                                          </button>
                                        ) : (
                                          <button
                                            className={getColor(
                                              "",
                                              "",
                                              item.onTrack
                                            )}
                                            style={{
                                              border: "none",
                                              borderRadius: "26px",
                                              padding: "5px 10px 5px 10px",
                                              fontSize: "12px",
                                              fontWeight: 300,
                                            }}
                                          >
                                            {" "}
                                            {item.onTrack
                                              ? "On Track"
                                              : "Behind"}
                                          </button>
                                        )}
                                      </td>
                                      <td>
                                        {item.totalTransactionAmount
                                          ? getCurrency(
                                              item.totalTransactionAmount
                                            )
                                          : getCurrency("0")}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            {list1.length === 0 && (
                              <React.Fragment>
                                <p className="text-center mt-3 text-dark w-100">
                                  No result
                                </p>
                              </React.Fragment>
                            )}

                            <div className="col-md-12 p-0">
                              {getAgentPerformanceDashboard.totalItemCount && (
                                <PaginationControlled
                                  onPageSizeChange={handlePageSizeChange2}
                                  onChange={handleChange2}
                                  page={page2}
                                  total={getAgentPerformanceDashboard.totalItemCount && getAgentPerformanceDashboard.totalItemCount}
                                  pageSize={pageSize2}
                                />
                              )}
                            </div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <div className="col-md-12 text-center">
                              <Placeholder
                                variant="text"
                                width={"100%"}
                                height={50}
                                animation="wave"
                                className="display-inline"
                              />
                            </div>
                            <div className="col-md-12 text-center">
                              <Placeholder
                                variant="text"
                                width={"100%"}
                                height={50}
                                animation="wave"
                                className="display-inline"
                              />
                            </div>
                            <div className="col-md-12 text-center">
                              <Placeholder
                                variant="text"
                                width={"100%"}
                                height={50}
                                animation="wave"
                                className="display-inline"
                              />
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div>{/* <TransactionChart /> */}</div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
